import { parseTimelineFilter } from '@/components/common/Filter/TimelineFilter/utils'
import { ReportFiltersValues } from '@/features/Analytics/stores/useAnalyticsFiltersStore/types'
import { CustomReportFilters, CustomReportFiltersParams } from '@/hooks'

export const mapFiltersToParams: (
    filters: ReportFiltersValues
) => CustomReportFiltersParams = (filters) => {
    const timelineValue = parseTimelineFilter(filters.timeline)

    const baseParams: CustomReportFilters = {
        nodeIds: filters.node.length ? filters.node : [],
        commodityTypeIds: filters.commodity.length
            ? filters.commodity
            : undefined,
        commodityTypeId: filters.commodity.length
            ? filters.commodity[0]
            : undefined,
        providerIds: filters.provider?.length ? filters.provider : undefined,
        contractIds: filters.contract.length ? filters.contract : undefined,
        panIds: filters.account?.length ? filters.account : undefined,
        tagIds: filters.tag.length ? filters.tag : undefined,
        facilityIds: filters.facility.length ? filters.facility : undefined,
        meterIds: filters.meter.length ? filters.meter : undefined,
        usnAccountIds: filters.usn?.length ? filters.usn : undefined,
        invoiceNumbers: filters.invoiceNo?.length
            ? filters.invoiceNo
            : undefined,
        unitOfMeasureId: filters.unitOfMeasureId?.length
            ? filters.unitOfMeasureId[0]
            : undefined,
    }

    if (filters.timeline.type === 'is') {
        return {
            ...baseParams,
            timeline: filters.timeline.value,
        }
    } else {
        return {
            ...baseParams,
            startDate: timelineValue.startDate,
            endDate: timelineValue.endDate,
        }
    }
}
